export default "__VITE_ASSET__1XyxLQGJ__"